export const formatNumber = (value: string | number | null): string => {
  if (!value) return '0';

  const num = typeof value === 'string' ? Math.round(parseFloat(value)) : Math.round(value);

  if (isNaN(num)) return '0';

  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }

  return num.toString();
};
